import React from 'react';
import useScreenSize from '../hooks/useScreenSize';

const VehicleDetailItem = ({ icon: Icon, label, value }) => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex items-start space-x-3 p-3 bg-white/60 backdrop-blur-sm rounded-lg border border-white/40">
      <div className={`${isMobile ? 'w-6 h-6 mt-0.5' : 'w-7 h-7 mt-0.5'} rounded-lg bg-white/80 flex items-center justify-center flex-shrink-0 shadow-sm`}>
        <Icon className={`${isMobile ? 'w-3 h-3' : 'w-3.5 h-3.5'} text-gray-600`} />
      </div>
      <div className="flex-1 min-w-0">
        <div className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 font-medium mb-1`}>
          {label}
        </div>
        <div className={`${isMobile ? 'text-sm' : 'text-base'} font-semibold text-gray-900 break-words`}>
          {value}
        </div>
      </div>
    </div>
  );
};

export default VehicleDetailItem;


